<template>
  <div class="page">
    <div class="page-container container-historical-revenue">
      <div>
        <h2>Revenue</h2>
        <!-- <div class="align-start"> -->
          <p>Upon seller’s approval, additional detail will be provided for the subject practice to ensure proper due diligence can be conducted.</p>
          
          <div class="sansation align-center mt-12">
            <CustomIcon name="srg-lightbulb" color="white" height="52" width="52" class="pb-2 ml-n4" />
            <span class="font-weight-black">{{ listing.revenue_percent_recurring }}%</span> <span class="ml-2 font-weight-medium">Recurring Revenue</span>
          </div>
        <!-- </div> -->
      </div>

      <div>
        <h3 class="text-center">{{ historicalRevenueLabel }}</h3>
        <HistoricalRevenueGraph
          :historicalRevenue="historicalRevenue"
          :tasof="listing.revenue_t12_asof_date"
        />
        <p class="page-help">
          <span v-if="listing.revenue_t12_asof_date">*{{asOfDate}}</span>
        </p>
      </div>
    </div>

    <div class="page-container container-revenue-breakdown">
      <h2>Revenue Breakdown</h2>
      <div>
        <RevenueBreakdownGraph
          class="graph-wrapper"
          :revenueSources="revenueSources"
        />

        <div class="revenue-breakdown-labels">
          <template v-for="(r, index) in revenueSources">

            <div class="revenue-breakdown-label" :key="index">
              <!-- {{index}} -->
            <div class="breakdown-label-description">
              <div class="box-no-wrap" :style="{'background-color': '#' + Object.values(r)[0].split('#')[1]}"></div>
              <label>{{ Object.keys(r)[0] }}</label>
            </div>

            <span>{{ Object.values(r)[0].split('#')[0] | currency }}</span>
            (<span>{{ revenuePercentOf(Object.values(r)[0].split('#')[0]) }}%</span>)
            <br>
          </div>
          </template>

        </div>

      </div>
    </div>
    <div class="page-container container-buyer-requirements">
      <h2>Other Revenue Details</h2>
      <div class="page-data-grid data-grid-table">
        
        <div v-if="this.listing.revenue_billing_cycle" class="page-data-item nested">
          <img src="../buyer-listing-details/full-details-content/assets/wallet.svg" />
          <div>
            <label>Billing Cycle:</label>
            <!-- <span>{{ this.listing.revenue_billing_cycle }}</span> -->
            <template v-for="(cycle,index) in (this.listing.revenue_billing_cycle || '').split(';')">
              <span v-bind:key="'billing-cycle-' + index">{{ cycle }}</span>
            </template>
          </div>
        </div>
        
        <div v-if="this.listing.revenue_management_aum" class="page-data-item nested">
          <img src="../buyer-listing-details/full-details-content/assets/conference.svg" />
          <div>
            <label>Management of AUM:</label>
            <!-- <span>{{ this.listing.revenue_management_aum }}</span> -->
            <template v-for="(aum,index) in (this.listing.revenue_management_aum || '').split(';')">
              <span v-bind:key="'management-aum-' + index">{{ aum }}</span>
            </template>
          </div>
        </div>
        
        <div v-if="this.listing.revenue_family_accounts" class="page-data-item nested">
          <img src="../buyer-listing-details/full-details-content/assets/family.svg" />
          <div>
            <label>Family Accounts:</label>
            <template v-for="(account,index) in (this.listing.revenue_family_accounts || '').split(';')">
              <span v-bind:key="'family-account-' + index">{{ account }}</span>
            </template>
          </div>
        </div>

        <div v-if="this.listing.revenue_financial_plans" class="page-data-item nested">
          <CustomIcon name="srg-planning-docs" color="#97C131" width="35" />
          <div>
            <label>Number of Financial Plans:</label>
            <!-- <span>{{ this.listing.revenue_financial_plans }}</span> -->
            <template v-for="(plans,index) in (this.listing.revenue_financial_plans || '').split(';')">
              <span v-bind:key="'financial-plans-' + index">{{ plans }}</span>
            </template>
          </div>
        </div>

        <div v-if="this.listing.revenue_average_fee_charged" class="page-data-item nested">
           <img src="../buyer-listing-details/full-details-content/assets/piggy-bank.svg" />
           <div>
            <label>Fee Structure:</label>
            <!-- <span>{{ this.listing.revenue_average_fee_charged }}</span> -->
            <template v-for="(fee,index) in (this.listing.revenue_average_fee_charged || '').split(';')">
              <span v-bind:key="'fee-charged-' + index">{{ fee }}</span>
            </template>
          </div>
        </div>
      </div>

      <div v-if="this.listing.revenue_other_notes" class="revenue_notes_box">
        <label>Other Notes Regarding Fees</label>
        <span v-html="this.listing.revenue_other_notes"></span>
      </div>
    </div>



    <BottomColorBar />
  </div>
</template>

<script>
import BottomColorBar from './partials/BottomColorBar'
import HistoricalRevenueGraph from './partials/HistoricalRevenueGraph'
import RevenueBreakdownGraph from './partials/RevenueBreakdownGraph'

export default {
  name: 'PdfPage3',
  components: {
    BottomColorBar,
    HistoricalRevenueGraph,
    RevenueBreakdownGraph,
  },
  props: {
    listing: {
      type: Object,
      default: () => ({}),
    }
  },
  data: () => ({
    fields: [
      'revenue_fees_recurring',
      'revenue_trails_recurring',
      'revenue_12b1s_recurring',
      'revenue_renewals_recurring',
      'revenue_hourly_recurring',
      'revenue_hourly_transactional',
      'revenue_financial_planning_recurring',
      'revenue_financial_planning_transactional',
      'revenue_other_recurring',
      'revenue_other_transactional',
      'revenue_osj_recurring',
      'revenue_osj_transactional',
      'revenue_accounting_recurring',
      'revenue_accounting_transactional',
      'revenue_direct_insurance_recurring',
      'revenue_direct_insurance_transactional',
      'revenue_securities_commissions_transactional',
      'revenue_insurance_commissions_transactional',
    ],
    fieldColors: [
      '#0096A6',
      '#97C131',
      '#D25642',
      '#5F6062',
      '#E6E7E8',
      '#CCEAED',
      '#FFC000',
      '#7030A0',
      '#00B0F0',
      '#ED7D31'
    ],
    fieldLabels: [
      'Fees',
      'Trails',
      '12b-1s',
      'Renewals (Insurance)',
      'Hourly (Recurring)',
      'Hourly (Transactional)',
      'Financial Planning Fees (Recurring)',
      'Financial Planning Fees (Transactional)',
      'Other (Recurring)',
      'Other (Transactional)',
      'OSJ / Overrides (Recurring)',
      'OSJ / Overrides (Transactional)',
      'Accounting / Taxes (Recurring)',
      'Accounting / Taxes (Transactional)',
      'Direct Insurance (Recurring)',
      'Direct Insurance (Transactional)',
      'Securities Commissions (Transactional)',
      'Insurance Commissions (Transactional)',
    ],
  }),
  computed: {
    historicalRevenueLabel () {
      const revenues = this.historicalRevenue
      console.log(revenues)
      let startYear = revenues && revenues.length
        ? revenues[0].year
        : this.listing.t12AsOfYear

      if (startYear === 0 || startYear === '0') {
        startYear = revenues[1].year
      }

      const endYear = revenues && revenues.length
        ? revenues[revenues.length - 1].year
        : this.listing.t12AsOfYear
      return `Historical Revenue ${startYear}-${endYear}`
    },

    historicalRevenue () {
      if (!this.listing.revenue_historical) return []
      let combinedRevenue = [
        ...Object.entries(this.listing.revenue_historical).map(([year, revenue]) => ({
          year: Number(year),
          revenue,
        })),
        {
          year: this.listing.t12AsOfYear,
          revenue: this.listing.revenue_t12_months,
        },
      ]

      combinedRevenue = combinedRevenue.filter((revObj) => {
        return revObj.year !== 0;
      })

      return combinedRevenue
        .sort(({ year: a }, { year: b }) => b - a)
        .slice(0, 7)
        .reverse()
    },

    asOfDate() {
      const date = new Date(this.listing.revenue_t12_asof_date);
      return 'As of ' + ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear();
    },

    revenueSourcesTotal() {
      let total = 0;
      this.revenueSources.map((r) => {
        let val = parseInt(Object.values(r)[0].split('#')[0], 10) || 0;
        total += val;
      });
      return total;
    },

    revenueSources () {
      let arrObj = [];
      // create arr of objs [ { field_label: value } ]
      this.fields.map((field, i) => {
        if ( this.listing[field] > 0) {
          arrObj.push({ [this.fieldLabels[i]]: this.listing[field]});
        }
      });
      // sort by values - large to small
      arrObj = arrObj
        .sort((a, b) => {
          return Object.values(b)[0] - Object.values(a)[0];
        });
      // pull out first 10
      arrObj = arrObj
        .slice(0, 10)
      arrObj.filter((obj) => {
        return Object.values(obj)[0] !== 0;
      });
      // adding color from ordered colors to each revenue source [ { field_label: value#color } ]
      arrObj = arrObj.map((obj, i) => {
        const v = Object.values(obj)[0];
        const k = Object.keys(obj)[0];
        return {
          [k]: v + this.fieldColors[i]
        };
      });
      return arrObj
    },
  },

  methods: {
    revenuePercentOf (amount) {
      return Math.round((parseInt(amount,10) / this.revenueSourcesTotal) * 100) || 0
    }
  }
}
</script>

<style scoped>
.pdf-container .page {
  padding-top: 20px;
}
.page-container {
  padding: 20px 50px;
}

.page-data-item {
  display: grid;
  grid-template-columns: 35px 35px auto;
  grid-column-gap: 10px;
  align-items: center;
  justify-content: left;
  margin: 5px 0;
}

.breakdown-label-description label {
  font-family: "SansationBold", sans-serif;
}

.container-historical-revenue {
  display: flex;
}

.container-historical-revenue > div:first-child {
  flex: 1 0 40%;
  display: flex;
  flex-direction: column;

  padding-top: 10px;
}

.page-data-card .page-data-item span {
  font-family: "SansationBold", sans-serif;
  font-size: 36pt;
  line-height: 38pt;
}

.page-data-card .page-data-item label {
  padding-left: 10px;

  font-family: "Sansation", sans-serif;
  font-size: 16pt;
  line-height: 18pt;
}

.box-no-wrap {
  height: 15px;
  width: 15px;
  display: inline-block;
}

.container-historical-revenue > div:last-child {
  flex: 1 0 auto;
  padding: 10px 20px;
}

.container-historical-revenue h2,
.container-historical-revenue h3 {
  margin-bottom: 10px;
}

.container-historical-revenue > div:first-child > div {  
  display: flex;
  flex-direction: row;
  background-color: #97C131; 
  color: white;
  justify-content: center;
  vertical-align: middle;
  font-size: 1.1rem !important;
}

.container-historical-revenue > div:last-child div {
  height: 250px;
  position: relative;
}

.page-data-card-box {
  width: 100%;
  height: 100px;
}

.page-data-card-box svg {
  margin-top: -10px;
  margin-right: -10px;
}

p.page-help {
  margin: 0;

  font-size: 9pt;
  text-align: right;
}

.container-revenue-breakdown {
  background-color: #0096A620;
  display: flex;
  flex-direction: column;
}

.container-revenue-breakdown > div  {
  display: flex;
  justify-content: space-between;
}

.container-revenue-breakdown .page-data-item-wrapper {
  flex: 1 0 250px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container-revenue-breakdown .item-gross-revenue {
  height: 160px;
  width: 200px;

  margin: auto;
  padding: 20px;

  display: grid;
  grid-template-columns: auto;
  align-items: center;
  justify-content: center;

  background-color: white;

  text-align: center;
}

.container-revenue-breakdown .item-gross-revenue span {
  font-family: "SansationBold", sans-serif;
  font-size: 18pt;
  line-height: 20pt;
}

.container-revenue-breakdown .item-gross-revenue label {
  font-size: 11pt;
  line-height: 13pt;
}

.container-revenue-breakdown .item-gross-revenue img {
  margin: 0 auto 5px;
}

.container-revenue-breakdown .graph-wrapper {
  position: relative;

  height: 230px;
  width: 230px;
}

/* .revenue-breakdown-labels .page-data-item > div:first-child {
  align-items: center;
  margin-bottom: 3px;
} */

.revenue-breakdown-labels {
  /* background: blue; */
  column-count: 2;
  column-gap: 0;
  /* height: 100%; */
}

.revenue-breakdown-label {
  font-family: "Sansation", sans-serif;
  width: 100%;
  display: inline-block;
  /* background: red !important; */
  /* float: left; */
}


.revenue-breakdown-labels  .data-item-values {
  /* display: grid;
  grid-template-columns: 40px 1fr; */
}

.container-expense-breakdown {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.revenue_notes_box {
  width: 50%; 
  border: 3px dashed #97C131;
  margin-top: 1rem;
  padding: .5rem 1rem;
}

.revenue_notes_box label {
  font-family: "SansationBold", sans-serif;
  font-size: .95rem;
  line-height: 1.5rem;
  color: #5F6062;
  display: block;
}

.revenue_notes_box span {
  font-family: "Sansation", sans-serif;
  font-size: .95rem;
  line-height: 1rem;
  color: #5F6062;
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details-as-pdf/PdfPage3.vue